import Aegis from '@tencent/aegis-web-sdk';
import { getUserId } from '@/infrastructure/auth';
import { ENV } from '@/infrastructure/env-config';
import { logger } from '@/infrastructure/logger';

const BUSI_CODE_OK = 0;

export const getAegisEnv = () => {
  const isPre = window.location.host === 'pre.bugly.woa.com';
  if (isPre) {
    return Aegis.environment.pre;
  } if (ENV.isProd) {
    return Aegis.environment.production;
  }

  return Aegis.environment.test;
};

const aegis = new Aegis({
  // 项目key，正式环境与测试环境分开上报
  id: ENV.aegisKey,
  env: getAegisEnv(),
  // 用户唯一id
  uin: getUserId(),
  // 开启接口测速
  reportApiSpeed: true,
  // 开启静态资源测速
  reportAssetSpeed: true,
  // spa 页面需要开启，页面切换的时候上报pv
  spa: true,
  api: {
    // 业务错误码上报
    retCodeHandler: (data: any, url?: string) => {
      let retCode;
      if (url?.match('/trpc')) {
        try {
          const resp = JSON.parse(data);
          retCode = resp?.base_rsp?.code ?? resp?.baseRsp?.code ?? resp?.BaseRsp?.code ?? resp?.code;
        } catch (e) {
          logger.error('aegis|retCodeHandler parse error');
        }
      }
      logger.info('aegis|report retCode:', retCode, url);
      return {
        isErr: retCode && retCode !== BUSI_CODE_OK,
        code: retCode,
      };
    },
    reportRequest: true,
    apiDetail: true,
  },
  beforeRequest: (data: any) => {
    if (data?.logType === 'log' && data?.logs?.msg?.includes('ResizeObserver')) {
      // 拦截：日志类型为log，且内容包含ResizeObserver的请求
      return false;
    }
    if (data?.logType === 'log' && data?.logs?.msg?.includes('Script error')) {
      // 拦截：日志类型为log，且内容包含Script error 的请求
      // 原因：本站跨域脚本已能捕获，运行时注入的外站脚本上报可以屏蔽掉，减少对正常错误的干扰
      return false;
    }
    return data;
  },
});

export { aegis };
